import styled from 'styled-components';

export const StyledH1 = styled.h1`
  font-family: 'font__bold';
  font-weight: bolder;
  font-size: 1.75rem;
`;
